import modal from 'ngtemplate-loader!./template.tpl.html';
import "./styles";

export const moduleName = 'rezflow.approveBooking'
export const name = 'approve';

const ELEMENT = new WeakMap();
const DOCUMENT = new WeakMap();

export default (MODULE) => {

  class Approve {

    /* @ngInject */
    constructor($document, $element, $timeout, $rootScope) {
      const vm = this;
      this.$timeout = $timeout;
      ELEMENT.set(this, $element);
      DOCUMENT.set(this, $document);
      this.user = $rootScope.user;
      this.reason = this.cancellations.find(template => template.default);
    }

    get company(){
      return this.user.activeCompany();
    }

    get cancellations(){
      return this.company.cancellations;
    }

    update() {
      const update = this.booking.update;
      const booking = angular.copy(this.booking);
      booking.status = 'active';
      update(this.fullUpdate ? booking : { status: 'active' }).then(res => {
        if(res.status) {
          this.booking.status = 'active';
          this.then();
          this.active = false;
        } else {
          if(/^not enough space/i.test(res.error)){
            this.active = true;
          }
        }
      });
    }

    waitlist() {
      const update = this.booking.update;
      const booking = angular.copy(this.booking);
      booking.status = 'waiting';
      update(this.fullUpdate ? booking : { status: 'waiting' }).then(res => {
        if(res.status) {
          // this.booking.status = 'waiting';
          this.active = false;
          this.wait();
        }
      });
    }

    style(){
      return this.active ? { 'display': 'block' } : undefined;
    }

    $onDestroy() {
      const $document = DOCUMENT.get(this);
    }

    $onInit() {}

  }

  angular.module(MODULE)
    .component(name, {
      bindings: {
        booking: '<',
        fullUpdate: '<',
        then: '&',
        wait: '&'
      },
      transclude: true,
      templateUrl: modal,
      controller: Approve
    });

  return name;

};


// WEBPACK FOOTER //
// ./client/assets/scripts/modules/reservations/approve/popover.js